import "./Header.css";
import { Link } from "react-router-dom";
import HeaderNav from "./HeaderNav";
import React, { useState, useEffect } from "react";
import { UserContext } from "../../../context/UserContext";
import { FaUserCheck } from "react-icons/fa";
import img from "../../../images/Logo2.png";
import { useAuth } from "../../../context/AuthContext";

const Header = () => {
  const { isLoggedIn } = useAuth();
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen(!isDropdownOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".dropdown")) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <>
      <header id="header" className="fixed-top stickyHeader">
        <div className="container-fluid">
          <Link to={"/"} className="logo">
            <img src={img} alt="logo" className="img-fluid" />
          </Link>

          <div className="hide-on-desktop">
            <Link to={isLoggedIn ? "/dane-uzytkownika" : "/login"} className="login-icon">
              <FaUserCheck />
            </Link>
          </div>

          <HeaderNav
            open={drawerOpen}
            setOpen={setDrawerOpen}
            isLoggedIn={isLoggedIn}
          />

          <Link to={"/umow-wizyte"} className="appointment-btn scrollto hide-on-mobile">
            UMÓW WIZYTĘ
          </Link>

          <div className="hide-on-mobile">
            {isLoggedIn ? (
              <Link to={"/dane-uzytkownika"} className="user">
                Mój profil &nbsp;
                <FaUserCheck
                  className="user-icon"
                  onClick={toggleDropdown}
                  aria-hidden="true"
                />
              </Link>
            ) : (
              <Link to={"/login"} className="login">
                ZALOGUJ
              </Link>
            )}
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;